import {FC} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFaceFrown, faFaceMeh, faFaceSmile} from "@fortawesome/free-solid-svg-icons";

interface Props {
    face: string;
    withColor?: boolean;
}

const EventFaceIcon: FC<Props> = (props) => {
    switch (props.face) {
        case "GOOD":
            return <FontAwesomeIcon icon={faFaceSmile} size={"2x"} color={props.withColor ? "green" : ""}/>
        case "NEUTRAL":
            return <FontAwesomeIcon icon={faFaceMeh} size={"2x"} color={props.withColor ? "gray" : ""}/>
        case "BAD":
            return <FontAwesomeIcon icon={faFaceFrown} size={"2x"} color={props.withColor ? "red" : ""}/>
    }

    return <b>НЕ Е ПОСТАВЕНА ОЦЕНКА</b>;
}

export default EventFaceIcon;
